import { ForumMinusIcon } from './ForumMinusIcon';

/**
 * author: nlsve
 * id 7FA0128C-C4DF-413B-9D6A-070344D26FFD
 * name forum-minus
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/forum-minus.svg
 * tags
 */
export const DialogueMinusIcon = ForumMinusIcon;
export default DialogueMinusIcon